module.exports = __webpack_public_path__ + "media/images/application/template/icon--download-c876e6a6a4530c25378281d47d63c7d1.svg";